import { Editor } from "@tiptap/core";

export class TableManager {
  #editor: Editor;

  constructor(editor: Editor) {
    this.#editor = editor;
  }

  // --- State Analysis ---

  isActive(): boolean {
    // Robust check: Check if any table-related node is active in the selection
    return (
      this.#editor.isActive("table") ||
      this.#editor.isActive("tableCell") ||
      this.#editor.isActive("tableHeader")
    );
  }

  canMergeCells(): boolean {
    return this.#editor.can().mergeCells();
  }

  canSplitCell(): boolean {
    return this.#editor.can().splitCell();
  }

  canAddColumnBefore(): boolean {
    return this.#editor.can().addColumnBefore();
  }

  canAddColumnAfter(): boolean {
    return this.#editor.can().addColumnAfter();
  }

  canDeleteColumn(): boolean {
    return this.#editor.can().deleteColumn();
  }

  canAddRowBefore(): boolean {
    return this.#editor.can().addRowBefore();
  }

  canAddRowAfter(): boolean {
    return this.#editor.can().addRowAfter();
  }

  canDeleteRow(): boolean {
    return this.#editor.can().deleteRow();
  }

  getNodeState() {
    if (!this.isActive()) {
      return null;
    }

    return {
      canMergeCells: this.canMergeCells(),
      canSplitCell: this.canSplitCell(),
      canAddColumnBefore: this.canAddColumnBefore(),
      canAddColumnAfter: this.canAddColumnAfter(),
      canDeleteColumn: this.canDeleteColumn(),
      canAddRowBefore: this.canAddRowBefore(),
      canAddRowAfter: this.canAddRowAfter(),
      canDeleteRow: this.canDeleteRow(),
      canToggleHeaderRow: this.#editor.can().toggleHeaderRow(),
      canToggleHeaderColumn: this.#editor.can().toggleHeaderColumn(),
      canToggleHeaderCell: this.#editor.can().toggleHeaderCell(),
      // Robust state detection
      isHeaderRow: this.#editor.isActive("tableHeader") && this.#editor.can().toggleHeaderRow(),
      isHeaderColumn:
        this.#editor.isActive("tableHeader") && this.#editor.can().toggleHeaderColumn(),
      isHeaderCell: this.#editor.isActive("tableHeader"),
      verticalAlign: this.#editor.getAttributes("tableCell").verticalAlign || "middle",
    };
  }

  // --- Commands ---

  insertTable(rows: number = 3, cols: number = 3, withHeaderRow: boolean = true) {
    this.#editor.chain().focus().insertTable({ rows, cols, withHeaderRow }).run();
  }

  deleteTable() {
    this.#editor.chain().focus().deleteTable().run();
  }

  addColumnBefore() {
    this.#editor.chain().focus().addColumnBefore().run();
  }

  addColumnAfter() {
    this.#editor.chain().focus().addColumnAfter().run();
  }

  deleteColumn() {
    this.#editor.chain().focus().deleteColumn().run();
  }

  addRowBefore() {
    this.#editor.chain().focus().addRowBefore().run();
  }

  addRowAfter() {
    this.#editor.chain().focus().addRowAfter().run();
  }

  deleteRow() {
    this.#editor.chain().focus().deleteRow().run();
  }

  mergeCells() {
    this.#editor.chain().focus().mergeCells().run();
  }

  splitCell() {
    this.#editor.chain().focus().splitCell().run();
  }

  toggleHeaderColumn() {
    console.log("Editor: Toggle Header Column");
    this.#editor.chain().focus().toggleHeaderColumn().run();
  }

  toggleHeaderRow() {
    console.log("Editor: Toggle Header Row");
    this.#editor.chain().focus().toggleHeaderRow().run();
  }

  toggleHeaderCell() {
    console.log("Editor: Toggle Header Cell");
    this.#editor.chain().focus().toggleHeaderCell().run();
  }

  setVerticalAlign(align: string) {
    console.log("Setting vertical align:", align);
    this.#editor.chain().focus().setCellAttribute("verticalAlign", align).run();
  }
}
